<button mat-mini-fab (click)="playVideo()" class="play-button play-button-animation">
  <mat-icon svgIcon="play-arrow"></mat-icon>
</button>
